import { render } from "./FlightForm.vue?vue&type=template&id=b06382ee&scoped=true"
import script from "./FlightForm.vue?vue&type=script&lang=js"
export * from "./FlightForm.vue?vue&type=script&lang=js"

import "./FlightForm.vue?vue&type=style&index=0&id=b06382ee&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06382ee"]])

export default __exports__